import moment from 'moment';
import { EVENTS, JANUARY_INDEX, CALENDAR_LAST_YEAR_PAGINATION_ALLOWED } from 'common/domain/constants';

class CalendarInlinePaginatorController {
  constructor($rootScope, EventEmitter) {
    'ngInject';
    this.rootScope = $rootScope;
    this.EventEmitter = EventEmitter;
  }

  $onInit() {
    this.month = this.date.getMonth();
    this.year = this.date.getFullYear();
    this.showingYear = this.year;
    this.momentDate = moment(this.date);
    this.momentDate.locale('es');
    this.monthName = this.momentDate.format('MMMM YYYY');
    this._resetIds();
  }

  nextMonth(){
    this.nextPage();
    this.tempDate = new Date(this.date.getFullYear(),this.date.getMonth() + 1 ,1);
    this._reset();
  }

  prevMonth(){
    this.prevPage();
    this.tempDate = new Date(this.date.getFullYear(),this.date.getMonth() - 1 ,1);
    this._reset();
  }

  _reset(){
    this.momentDate = moment(this.tempDate);
    this.momentDate.locale('es');
    this.monthName = this.momentDate.format('MMMM YYYY');
    this.month = this.tempDate.getMonth();
    this.year = this.tempDate.getFullYear();
    this.checkYearChanges();

    this._resetIds();
    this._resetBindings();
  }

  _resetIds(){
    this.rowsId = this.id;  
    if(this.id){
      this.idCalendar = this.id[0];
    }
  }
  _resetBindings(){
    if(!this.rowsId){
      return this._bindCalendarChangeEvent(this.tempDate);
    }

    this.rowsId.forEach((id) => {
      this._bindCalendarChangeEvent(this.tempDate, this.idCalendar, id);
    });
  }

  _bindCalendarChangeEvent( newDate, idCalendar, lineCalendarId){
    this.rootScope.$broadcast(EVENTS.CALENDAR_INLINE_CHANGE_DATE, {newDate: newDate, id: lineCalendarId , idHeader: idCalendar});
  }

  checkYearChanges() {
    if(this.year !== this.showingYear){
      this.onYearPaginationChanges(this.EventEmitter({year: this.year}));
      this.showingYear = this.year;
    }
  }

  hidePrevArrow() {
    return this.showingYear === CALENDAR_LAST_YEAR_PAGINATION_ALLOWED && this.month === JANUARY_INDEX;
  }
}

export default CalendarInlinePaginatorController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInlinePaginator/calendarInlinePaginator.controller.js